import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { IUser } from '../../interfaces/user.interface';
import { ProfileService } from '../../services/profile.service';
import { StorageService } from '../../services/storage.service';
import { Router } from '@angular/router';

@Component({
  selector: 'hadsup-profile',
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss',
  standalone: false,
})
export class ProfileComponent implements OnInit, OnDestroy {
  public userObj: IUser = {} as IUser;
  private subscriptions = new Subscription();
  public loadingData = false;
  public prefix: string = '';
  public phone: string = '';
  constructor(
    private router: Router,
    private storageService: StorageService,
    private profileService: ProfileService,
  ) { }

  ngOnInit(): void {
    this.GetProfileDetails();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  GetProfileDetails() {
    this.loadingData = true;
    this.subscriptions.add(
      this.profileService.GetProfile().subscribe((response: any) => {
        if (response) {
          this.userObj = response.data;
          this.storageService.setProfileInfo(response.data);
          if (this.userObj.phone) {
            const fullPhone = this.userObj.phone.split('_');
            if (fullPhone?.length == 2) {
              this.prefix = fullPhone[0];
              this.phone = fullPhone[1];
            } else {
              this.phone = fullPhone[0];
            }
          }
        }
        this.loadingData = false;
      })
    );
  }
  logOut() {
    this.storageService.removeAll();
    this.storageService.removeAccessToken();
    this.router.navigate(['/login'])
  }

}

